import { bindable, inject } from 'aurelia';

@inject(Element)
export class AnimateOnChangeCustomAttribute {
    @bindable value;

    constructor(element) {
        this.element = element;
    }

    valueChanged() {
        this.element.classList.add('background-animation-add');
        this.element.addEventListener('animationend', () => {
            this.element.classList.remove('background-animation-add');
        }, { once: true });
    }
}
